import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "@env/environment";
import {catchError, retry} from "rxjs/operators";
import {BehaviorSubject, Observable, of} from "rxjs";
import {ConstantsService} from "@app/services/constants/constants.service";
import {Projects} from "@app/interfaces/projects";
import {BackendResponse} from "@app/interfaces/backendResponse";

export interface Project {
    _id: any, // any zato sto moze biti string ili number (number id stize iz proventuma)
    name: string,
    logo: string
}


@Injectable({
    providedIn: 'root'
})
export class ProjectsService {

    apiURL = environment.apiURL;
    userActiveProject = new BehaviorSubject<Projects>(null);

    constructor(private http: HttpClient,
                private constants: ConstantsService) {
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            
            return of(result as T);
        };
    }

    //svi projekti
    getProjects() {
        let params = new HttpParams().set('user_id', this.constants.creator_id);
        return this.http.get(this.apiURL + '/projects/getProjects', {params: params})
            .pipe(retry(1),
                catchError(this.handleError('getProjects')));

    }


    saveProject(name, type) {
        let params = new HttpParams().set('name', name).set('type', type);
        return this.http.post(this.apiURL + '/task/saveNewProject', params)
            .pipe(retry(1),
                catchError(this.handleError('saveNewProject')))
    }

    activateProject(projectId) {
        let params = new HttpParams().set('user_id', this.constants.creator_id).set('project_id', projectId);
        return this.http.post(this.apiURL + '/projects/setUserActiveProject', params)
            .pipe(
                retry(1),
                catchError(this.handleError('setUserActiveProject')));
    }

    // samo aktivni projekat po useru
    getUserActiveProject() {
        let params = new HttpParams().set('user_id', this.constants.creator_id);
        return this.http.get(this.apiURL + '/projects/getUserActiveProject', {params: params})
            .pipe(retry(1),
                catchError(this.handleError('getUserActiveProject')));
    }



}
